document.addEventListener('DOMContentLoaded', function () {
  const sliderElement = document.getElementById(
    'featured-products-mobile-slider'
  );

  if (!sliderElement) return;

  const slider = new Splide(sliderElement, {
    type: 'slide',
    arrows: true,
    pagination: false,
    perPage: 2,
    perMove: 1,
    drag: true,
    speed: 600,
    gap: 28,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        destroy: true
      }
    }
  });

  slider.mount();
});
